// @ts-nocheck
import * as React from 'react';
import University from 'components/University';
import PlanCard from 'components/PlanCard';
import type { ChoosePlanProps } from './ChoosePlan.types';
import {
  Container,
  Wrapper,
  Title,
  Alternative,
  CtaContainer,
  Header,
  Cta,
} from './ChoosePlan.styles';

const choosePlanLabels = {
  title: 'Choose the best plan for your goals',
  or: 'or',
  enroll: 'Enroll',
  enrollForFree: 'Enroll for Free',
  courseTitle: 'Applied Data Science with SQL',
  certificateCompletion: 'Get a certificate of completition',
};
const courseType = {
  paid: 'paid',
  free: 'free',
};

const ChoosePlan = ({
  onEnroll,
  onEnrollForFree,
  price,
  university,
  planDetails,
  type,
  sectionTitle,
  courseTitle,
  cardTitle,
  icon,
  showPlanSwitcher,
}: ChoosePlanProps): React.ReactElement<any> => {
  const isFreePlan = type === courseType.free;
  return (
    <Wrapper invertColor={isFreePlan}>
      {courseTitle && <Header>{courseTitle}</Header>}
      <Container>
        <University university={university} />
        <Title>{sectionTitle}</Title>
        <PlanCard
          icon={icon}
          title={cardTitle}
          invertColor={isFreePlan}
          details={planDetails}
          onEnroll={onEnroll}
          price={price}
          ctaText={isFreePlan ? choosePlanLabels.enrollForFree : choosePlanLabels.enroll}
        />
        {showPlanSwitcher && (
          <>
            <Alternative>{choosePlanLabels.or}</Alternative>
            <CtaContainer>
              <Cta onClick={onEnrollForFree} data-testid='choose-plan-button'>
                {isFreePlan
                  ? choosePlanLabels.certificateCompletion
                  : choosePlanLabels.enrollForFree}
              </Cta>
            </CtaContainer>
          </>
        )}
      </Container>
    </Wrapper>
  );
};

export default ChoosePlan;
